import { render, staticRenderFns } from "./Reglamentos-lineamientos.vue?vue&type=template&id=696e3e67&scoped=true"
import script from "./Reglamentos-lineamientos.vue?vue&type=script&lang=js"
export * from "./Reglamentos-lineamientos.vue?vue&type=script&lang=js"
import style0 from "./Reglamentos-lineamientos.vue?vue&type=style&index=0&id=696e3e67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e3e67",
  null
  
)

export default component.exports